module.exports = __webpack_public_path__ + "static/media/grayfox.636246b5.svg";